import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { HistoriqueModel } from 'src/app/models/historique/historique.model';
import { HistoriqueService } from 'src/app/services/historique.service';
import { UsersService } from 'src/app/services/users.service';

import { ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-historique',
  standalone: true,
  templateUrl: './historique.component.html',
  styleUrls: ['./historique.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatTooltipModule,
    MatPaginatorModule,
  ],
})
export class HistoriqueComponent implements OnInit, AfterViewInit {
  @Input() uidObject!: string;
  @Input() limit?: number;

  @Input() objectId!: string;
  @Input() platform?: string;
  @Input() uidEntreprise?: string;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  dataSource = new MatTableDataSource<HistoriqueModel>();
  displayedColumns: string[] = ['date', 'auteurNom', 'nature', 'description'];

  uidToUser: Map<string, string> = new Map();

  constructor(
    private historiqueService: HistoriqueService,
    private usersService: UsersService
  ) {}

  ngOnInit(): void {
    this.usersService.getSessionCurrentUser().subscribe({
      next: (user) => {
        const orgId = user?.organizationId;
        if (!orgId) {
          return;
        }

        // 1. Récupération des utilisateurs pour le mapping id → display
        this.usersService.getUsers().subscribe({
          next: (users) => {
            users.forEach((u) => this.uidToUser.set(u.id, u.display));

            // 2. Récupération des historiques filtrés
            this.historiqueService.getByEntreprise(orgId).subscribe({
              next: (data) => {
                const filtres = (data ?? [])
                  .filter((h) => {
                    // 1. Filtrage par objet sélectionné
                    if (this.uidObject && h.uidObject !== this.uidObject) {
                      return false;
                    }

                    // 2. Filtrage fonctionnel (optionnel, tu peux même l’enlever plus tard)
                    const desc = h.description?.toLowerCase() || '';
                    return (
                      desc.includes('extension') || desc.includes('groupe')
                    );
                  })
                  .map((h) => ({
                    ...h,
                    auteurNom:
                      this.uidToUser.get(h.uidObject ?? '') || 'Système',
                  }))
                  .sort(
                    (a, b) =>
                      new Date(b.dateHistorique!).getTime() -
                      new Date(a.dateHistorique!).getTime()
                  );

                console.log('[HISTO] uidObject =', this.uidObject);
                console.log('[HISTO] limit =', this.limit);
                console.log('[HISTO] total après filtre =', filtres.length);

                // Mode pagination → on garde tout
                this.dataSource.data = filtres;

                this.paginator.pageSize = 5;
                this.paginator.firstPage();
              },
              error: (err) => {
                console.error('Erreur chargement historique', err);
              },
            });
          },
          error: (err) => {
            console.error('Erreur chargement utilisateurs', err);
          },
        });
      },
      error: (err) => {
        console.error('Erreur récupération session', err);
      },
    });
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  getNatureIcon(nature: string): string {
    switch (nature.toLowerCase()) {
      case 'create':
        return 'add_circle';
      case 'update':
        return 'edit';
      case 'delete':
        return 'delete';
      case 'notice':
        return 'info';
      default:
        return 'help';
    }
  }
}
